module.exports = __webpack_public_path__ + "static/media/wifi-slash.b0232f83.svg";